<template>
  <header id="header" style="height: 100%">
    <div class="navbar navbar-inverse" role="banner">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle"
            data-toggle="collapse"
            data-target=".navbar-collapse"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>

          <a class="navbar-brand" href="javascript: void(0)">
            <img
              src="/images/logo_new.png"
              alt=""
              style="margin-top: 20px; margin-bottom: 20px;width: 200px;"
            />
          </a>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li class="active">
              <router-link to="/"
                ><i class="el-icon-s-home"></i> Home</router-link
              >
            </li>
            <li class="dropdown">
              <router-link to="/browse"
                ><i class="el-icon-view"></i> Browse</router-link
              >
            </li>
            <li class="dropdown">
              <router-link to="/search"
                ><i class="el-icon-search"></i> search</router-link
              >
            </li>
            <li class="dropdown">
              <router-link to="/predict"
                ><i class="el-icon-magic-stick"></i> predict</router-link
              >
            </li>
            <!-- <li class="dropdown">
              <router-link to="/downloads"><i class="el-icon-download"></i> downloads</router-link> 
               <ul role="menu" class="sub-menu">
                <li><router-link to="/">2020</router-link></li>
                <li><router-link to="/">2019</router-link></li>
              </ul>
            </li>-->
            <li>
              <router-link to="/about"
                ><i class="el-icon-phone"></i> About us</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  // mounted() {
  //   // Search
  //   $(".fa-search").on("click", function () {
  //     $(".field-toggle").fadeToggle(200);
  //   });
  // },
};
</script>

<style>
.navbar-right {
  float: right !important;
  margin-right: -35px;
}
</style>